import { PropsWithChildren, useMemo, useState } from 'react';

import { AppModel, AppSecrets } from '../../../modules/Apps';
import { createNullableContext, useNullableContext } from '../../../utils/Context';
import { PopoverStateReturn } from '../../common/Drawer/Drawer.context';

interface AppsTableContextValues {
  createAppDrawerState: PopoverStateReturn;
  editAppDrawerState: PopoverStateReturn;
  viewAppDrawerState: PopoverStateReturn;
  editingApp: AppModel | undefined;
  appSecrets: AppSecrets | undefined;
  setEditingApp: (value: AppModel | undefined) => void;
  setAppSecrets: (value: AppSecrets | undefined) => void;
}

interface AppsTableContextProviderProps {
  createAppDrawerState: PopoverStateReturn;
  editAppDrawerState: PopoverStateReturn;
  viewAppDrawerState: PopoverStateReturn;
}

export const AppsTableContext = createNullableContext<AppsTableContextValues>('AppsTableContext');

export const useAppsTableContext = () => useNullableContext(AppsTableContext);

export const AppsTableContextProvider = ({
  children,
  createAppDrawerState,
  editAppDrawerState,
  viewAppDrawerState,
}: PropsWithChildren<AppsTableContextProviderProps>) => {
  const [editingApp, setEditingApp] = useState<AppModel | undefined>();
  const [appSecrets, setAppSecrets] = useState<AppSecrets | undefined>();

  const value = useMemo(
    () => ({
      createAppDrawerState,
      editAppDrawerState,
      viewAppDrawerState,
      editingApp,
      appSecrets,
      setEditingApp,
      setAppSecrets,
    }),
    [appSecrets, createAppDrawerState, editAppDrawerState, editingApp, viewAppDrawerState],
  );

  return <AppsTableContext.Provider value={value}>{children}</AppsTableContext.Provider>;
};
